/**
 * Scrollable content slot for dialog body. Uses flex-1 + overflow-y-auto so content scrolls within the shell.
 * Architectural Context: Pure UI molecule. Use as Dialog.Body.
 *
 * @param children - Dialog body content
 * @param className - Optional additional classes
 *
 * @example
 * <Dialog.Body className="space-y-4">
 *   <p>Long scrollable content</p>
 * </Dialog.Body>
 */

import React from 'react';

export interface DialogBodyProps {
  /** Dialog body content */
  children: React.ReactNode;
  /** Class name for the container */
  className?: string;
}

export const DialogBody: React.FC<DialogBodyProps> = ({
  children,
  className = '',
}) => (
  <div className={`flex-1 overflow-y-auto overflow-x-hidden ${className}`}>
    {children}
  </div>
);
